import React from 'react';

import { utils } from '../utils';
import { formatMoney, theme } from '../constants';
import { ProductType } from '../types';

type Props = {
  item: ProductType;
  containerStyle?: React.CSSProperties;
};

export const ProductPrice: React.FC<Props> = ({ containerStyle, item }) => {
  return (
    <div style={{ ...utils.rowCenter(), ...containerStyle }}>
      {item.oldPrice && (
        <span
          style={{
            marginRight: 4,
            color: theme.colors.black,
            textDecorationLine: 'line-through',
            ...theme.fonts.DM_Sans_400Regular,
            fontSize: 12,
          }}
        >
          ETB&nbsp;{formatMoney(item.oldPrice)}
        </span>
      )}
      <span
        style={{
          fontSize: 14,
          ...theme.fonts.DM_Sans_500Medium,
          color: theme.colors.black,
          fontWeight: 'bold'
        }}
      >
        ETB&nbsp;
        {item.default_sales_type === 'PACK'
          ? formatMoney(Number(item.price_per_pack) * (item.quantity || 1))
          : formatMoney(Number(item.price) * (item.quantity || 1))}

      </span>
    </div>
  );
};
